import currentVersion from './current_version';
import submitVersion from './submit_version';
import sortedVersions from './sorted_versions';

export default {
  currentVersion,
  submitVersion,
  sortedVersions,
};
